import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";
import { useAuth } from "lib/auth/AuthContext";

interface UseLaunchDarklyResult {
  flags: Record<string, any>;
}

export function useLaunchDarkly(): UseLaunchDarklyResult {
  const client = useLDClient();
  const flags = useFlags();
  const { user } = useAuth();

  useEffect(() => {
    const initialize = async (): Promise<void> => {
      if (!client) return;
      try {
        if (user?.id) {
          await client.identify({
            key: user.id,
            name: user.name,
            email: user.email,
          });
        }
        await client.waitForInitialization();
      } catch (err) {
        console.error("LaunchDarkly initialization error:", err);
      }
    };
    void initialize();
  }, [client, user]);
  return { flags };
}
